//TODO: Is this module declaration needed at all?
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [],
  imports: [],
  exports: [],
})
export class HsCompositionsLayerParserModule {}
